import { render } from "./App.vue?vue&type=template&id=39e1c8d8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=39e1c8d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39e1c8d8"

export default script